import _Statistic from './Statistic';
import './style/index.js';

export type { StatisticProps, StatisticRef } from './Statistic';
export * from './type';

export const Statistic = _Statistic;
export default Statistic;
